<template>
  <div id="home">
    <keep-alive>
      <Top :is-front-page="true" :welcome="true" @user="isShowUser = true" />
    </keep-alive>
    <div id="main">
      <Hint />
      <Carousel />
      <Shortcuts />
      <!-- <Stickers /> -->
    </div>
    <div v-if="courses[0]">
      <SectionView
        v-for="item in courses.filter(a => a.type.front_page)"
        :key="item.type.id"
        :type="item.type.id"
        :title="item.type.name"
        :subtitle="item.type.type_subtitle"
        :data="
          item.course.map(course => {
            return {
              title: course.title,
              subtitle: course.subtitle,
              events: course.events,
              bgd: course.img,
              key: course.id,
              url: `/courses/${course.id}`,
            }
          })
        "
      />
    </div>
    <Videos :is-show-buy="true" :isShowMore="false" video-type="12" />
    <Videos :is-show-buy="true" />
    <Features />
    <NavFooter />
    <User v-if="isShowUser" @close="isShowUser = false" />
  </div>
</template>
<script>
import NavFooter from "@/components/public/footer"
import Top from "@/components/public/top"
import User from "@/components/my/User"
import SectionView from "./Section"
import Shortcuts from "./Shortcuts"
import Carousel from "./Carousel"
import Videos from "./Videos"
import Stickers from "./Stickers"
import Features from "./Features"
import Hint from "./Hint"

export default {
  name: "Home",
  components: {
    Top,
    Carousel,
    User,
    NavFooter,
    Shortcuts,
    Videos,
    Stickers,
    SectionView,
    Features,
    Hint,
  },
  data() {
    return {
      isShowUser: false,
      list: "",
      courses: [],
      count: "",
      news: "",
      hangouts: "",
      slides: "",
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
  },
  created() {
    this.getCourses()
    this.wechatInit()
  },
  mounted() {
    if (this.$route.query.promptFollow) {
      this.$popup("follow")
    }
  },
  activated() {
    this.isShowUser = false
  },
  deactivated() {
    this.$bus.$emit("popup", false)
    document.body.classList.remove("noscroll")
  },
  methods: {
    async getCourses() {
      const data = await this.$api.course.LIST()
      data.forEach(i => {
        i.course.forEach(course => {
          course.events.forEach(event => {
            event.price = parseFloat(event.price)
          })
        })
      })
      this.courses = data
    },
    wechatInit() {
      wx.ready(() => {
        bus.wxShareConfig({
          type: "all",
          url: "/#/activities",
          name: this.$store.state.info.brandName,
          desc: "邀请好友听课立得现金礼包，还有趣蒙直播课、同城拼课等最具革命性的中外教英语。",
        })
      })
    },
  },
}
</script>
<style lang="scss">
// @import "../../../static/css/public.scss";

#home {
  background: white;
  padding-bottom: $bottom-bar;
  padding-bottom: $iphone-x-bottom-bar;
  @include avenir();
}

.section-title {
  color: $black;
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 5px;
  padding-right: 5%;
}

.section-description {
  color: $black;
  font-weight: 300;
  font-size: 15px;
  padding-right: 5%;
}

.section-title-more {
  color: $blue;
  font-size: 13px;
  float: right;
  font-weight: 400;
  text-decoration: none;
}

.news-item-container {
  width: 90%;
  margin-left: 5%;
  background: white;
  margin-bottom: 20px;

  .news-item-wrapper {
    overflow: auto;
    white-space: nowrap;
    margin-left: -5%;
    .news-item:first-child {
      margin-left: 5%;
    }
    .news-item {
      display: inline-block;
      width: 150px;
      min-height: 160px;
      margin-right: 15px;
      vertical-align: top;

      .view-more {
        display: flex;
        align-items: center;
        border-radius: 3px;
        background: #ededed;
        text-align: center;
        font-size: 15px;
        height: 90px;
        margin-top: 15px;

        a {
          width: 100%;
          color: #606060;
        }
        span {
          font-weight: 500;
        }
      }

      .meta {
        white-space: -moz-pre-wrap !important;
        white-space: -pre-wrap;
        white-space: -o-pre-wrap;
        white-space: pre-wrap;
        word-wrap: break-word;
        white-space: -webkit-pre-wrap;
        word-break: break-all;
        white-space: normal;
        padding: 5px 0;

        h1 {
          font-size: 13px;
          font-weight: 500;
          line-height: 1.4;
          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        h1.news-title {
          -webkit-line-clamp: 2;
        }
        h2 {
          font-size: 13px;
          color: $black;
          font-weight: 300;
          margin-top: 5px;
        }

        p,
        p p {
          font-size: 15px;
          color: $grey;

          text-overflow: ellipsis;
          overflow: hidden;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .thumbnail {
        margin-top: 15px;
        width: 100%;
        height: 90px;
        background: #ededed;
        border-radius: 3px;
        box-shadow: 0 0 25px 0 #efefef;
        display: block;
        background-position: center;
        background-size: cover;
        display: block;
      }
    }
  }
}

.news-item-container:first-child {
  margin-top: 0;
}

@media screen and (max-width: 320px) {
}

@media screen and (min-width: 321px) and (max-width: 414px) {
}

/*平板电脑*/

@media only screen and (min-device-width: 768px) {
  .news-item-container {
    .section-title {
      font-size: 1.5rem;
    }
    .section-description,
    .section-description * {
      font-size: 1rem;
    }

    .news-item-wrapper {
      .news-item {
        width: 250px;
        .thumbnail {
          height: 150px;
        }
        .meta {
          h1 {
            font-size: 1rem;
          }
          h2 {
            font-size: 0.9rem;
          }
        }
      }
    }
  }
}
</style>
